
import { useMemo } from "react";

export const useNodeRenderConfig = () => {
  return useMemo(() => ({
    NODE_BORDER_WIDTH: 1,
    NODE_TEXT_MAX_WIDTH: 35,
    BASE_NODE_WIDTH: 25,
    NODE_ASPECT_RATIO: 16/9,
    SELECTED_NODE_SCALE: 1.5,
    HOVERED_NODE_SCALE: 1.2,
    DEFAULT_NODE_SCALE: 0.7,
    INITIAL_ZOOM_FACTOR: 2.5
  }), []);
};
